export default "__VITE_ASSET___1B7FLGN__"